export { Time } from './time';
export type { TimeProps } from './time';
